import { createSlice } from '@reduxjs/toolkit'

export const notebookSlice = createSlice({
  name: 'notebook',
  initialState: {
    value: null,
  },
  reducers: {
    storeNotebook: (state, action) => {
      state.value = action.payload
    },
    cleanNotebook: (state) => {
        state.value = null;
    }
  },
})
export const { storeNotebook, cleanNotebook } = notebookSlice.actions

export default notebookSlice.reducer